(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fakanal-sales-funnel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.fakanal-funnel');
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      const radios = [...section.querySelectorAll('input[type="radio"][data-variant-id]')];
      const price = section.querySelector('[data-price]');
      const compare = section.querySelector('[data-compare]');
      const savings = section.querySelector('[data-savings]');
      const shipping = section.querySelector('[data-shipping]');
      const stock = section.querySelector('[data-stock-message]');
      const add = section.querySelector('[data-add-to-cart]');
      const buy = section.querySelector('[data-buy-now]');

      const selected = () => radios.find((radio) => radio.checked && !radio.disabled);
      const sync = () => {
        const radio = selected();
        if (!radio) {
          add.disabled = true;
          buy.disabled = true;
          stock.hidden = false;
          return;
        }
        price.textContent = radio.dataset.price;
        compare.textContent = radio.dataset.compare;
        savings.textContent = radio.dataset.save;
        savings.hidden = !radio.dataset.save;
        shipping.textContent = radio.dataset.shipping;
        add.textContent = radio.dataset.button;
        add.disabled = false;
        buy.disabled = false;
        stock.hidden = true;
      };

      radios.forEach((radio) => radio.addEventListener('change', sync));
      if (!selected()) {
        const firstAvailable = radios.find((radio) => !radio.disabled);
        if (firstAvailable) firstAvailable.checked = true;
      }
      sync();

      section.querySelectorAll('[data-gallery-image]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const image = section.querySelector('.fakanal-funnel__main-image');
          if (!image) return;
          image.src = thumb.dataset.galleryImage;
          image.alt = thumb.dataset.galleryAlt;
          section.querySelectorAll('[data-gallery-image]').forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');
        });
      });

      add.addEventListener('click', async () => {
        const radio = selected();
        if (!radio) return;
        add.disabled = true;
        const original = add.textContent;
        add.textContent = 'Adding…';
        try {
          const response = await fetch(section.dataset.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(radio.dataset.variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart error');
          add.textContent = 'Added — View cart';
          window.setTimeout(() => { window.location.href = section.dataset.cartUrl; }, 450);
        } catch (error) {
          add.textContent = original;
          add.disabled = false;
          stock.textContent = 'This pack could not be added. Please refresh and try again.';
          stock.hidden = false;
        }
      });

      buy.addEventListener('click', () => {
        const radio = selected();
        if (!radio) return;
        const root = section.dataset.root.endsWith('/') ? section.dataset.root : `${section.dataset.root}/`;
        window.location.href = `${root}cart/${radio.dataset.variantId}:1?checkout`;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
